export default "__VITE_ASSET__Dt$cfWPC__"